import { Box, Stack } from '@mui/material';
import { ExternalLinkIcon } from 'lucide-react';

import type { GetOrganisationMonitoringQuery } from '@graphql/__generated__/graphql';

export type OrganisationMonitoringOrganisation = NonNullable<
  GetOrganisationMonitoringQuery['organisations_by_pk']
>;

export const getStripeCustomerUrl = (customerId: string) =>
  `https://dashboard.stripe.com/customers/${customerId}`;

export const getCloseLeadUrl = (leadId: string) =>
  `https://app.close.com/lead/${leadId}`;

export const normalizeStripeIds = (ids: string[]) =>
  Array.from(new Set(ids.map(id => id.trim()).filter(Boolean)));

export const getOrganisationSourceSearchQueries = (
  organisation: OrganisationMonitoringOrganisation,
) =>
  Array.from(
    new Set(
      [
        organisation.name,
        ...organisation.teams.flatMap(team => [
          team.name,
          ...team.teams_users.flatMap(
            teamUser =>
              teamUser.user?.primaryEmail.map(email => email.email) ?? [],
          ),
        ]),
      ].filter((query): query is string => Boolean(query)),
    ),
  ).slice(0, 8);

export const ExternalLinkChipLabel = ({ label }: { label: string }) => (
  <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5, minWidth: 0 }}>
    <Box
      component="span"
      sx={{
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {label}
    </Box>
    <ExternalLinkIcon style={{ flexShrink: 0 }} size={14} />
  </Stack>
);
